import { RequestFactory } from "@/requests/RequestFactory";
const pessoaAlcancadaRequest = RequestFactory.get("pessoaAlcancada");


export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {}
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchPessoasAlcancadasByProjeto: ({ dispatch }, projetoId) => {
      const payload = { resource: 'pessoaAlcancada', id: projetoId }
      return dispatch('fetchItemsParent', payload, { root: true })
    },

    deletePessoaAlcancada({ commit, dispatch }, payload) {
      dispatch('requestOn');
      const pessoaAlcancadaId = payload.pessoaAlcancadaId;
      return pessoaAlcancadaRequest.delete(payload).then(() => {
        dispatch('requestOff');
        
        const payloadCommit = { resource: 'pessoaAlcancada', itemId: pessoaAlcancadaId }        
        commit('deleteItem', payloadCommit, { root: true })

        const notification = {
          type: 'success',
          message: 'Pessoa removida com sucesso.'
        }
        return dispatch('notification/add', notification, { root: true })
      })
    },

    salvarPessoaAlcancada({commit, dispatch}, payload) {
      dispatch('requestOn');
      return pessoaAlcancadaRequest.post(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'pessoaAlcancada', item: response.data}

        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Pessoa salva com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        return response.data
      })
      .catch(error => {
        dispatch('requestOff');

        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error

      });
    },

    editarPessoaAlcancada({commit, dispatch}, payload) {
      dispatch('requestOn');
      return pessoaAlcancadaRequest.put(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'pessoaAlcancada', item: response.data}

        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Pessoa editada com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        return response.data
      })
      .catch(error => {
        dispatch('requestOff');

        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error

      });
    },

  },

  getters: {
    byProjetoId: (state) => projetoIdId => {
      if (state.items) {
        return Object.values(state.items).filter(p => p.projetoId === projetoIdId)
      }
      return []
    },
  }
}
